import {
  Box,
  Display,
  FlexDirection,
  JustifyContent,
  Main,
  withCitrusTheme,
} from '@gousto-internal/citrus-react';
import { PricingDTOTypes } from '@repo/experience-api-client';
import { PricingHero } from './PricingHero';
import { PricingExplorer } from './PricingExplorer';
import { PricingFaq } from './PricingFaq';
import { PricingFootnote } from './PricingFootnote';

const ContentWrapper = withCitrusTheme(Box, (theme) => ({
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(14),
  '@media (min-width: 768px)': {
    paddingTop: theme.spacing(8),
  },
}));

type Props = {
  pricingOptions: PricingDTOTypes.PricingOptionsResponseData;
};

export function PricingPageRedesign({ pricingOptions }: Props): JSX.Element {
  return (
    <Main id="main">
      <ContentWrapper display={Display.Flex} justifyContent={JustifyContent.Center} paddingH={4}>
        <Box
          width="100%"
          maxWidth="640px"
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          gap={[6, null, 8]}
        >
          <PricingHero />
          <PricingExplorer options={pricingOptions.options} />
          <PricingFaq discountSteps={pricingOptions.discountSteps} />
        </Box>
      </ContentWrapper>
      <PricingFootnote
        options={pricingOptions.options}
        discountSteps={pricingOptions.discountSteps}
      />
    </Main>
  );
}
